module.exports = __webpack_public_path__ + "img/filledstar.d360235c.svg";